import {
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

const methodsToHandle = ['POST', 'PUT', 'DELETE'];

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
    private authService = inject(AuthService);


    intercept(req: HttpRequest<any>, next: HttpHandler) {
        // if (req.url.includes('api')) {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.authService.accessToken}`,
        });
        return next.handle(req.clone({ headers }));
        // }

        // return next.handle(req);
    }
}
